/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../../components/InternalMenu/Menu'

import Switch from "react-switch"

import { get, put } from '../../../../services/http'
import { notify } from '../../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import { useParams } from 'react-router'

export default function index() {
  document.title = 'جزئیات استخدام'

  const navigate = useNavigate()
  const { id } = useParams()

  const [name, setName] = useState('')
  const [father, setFather] = useState('')
  const [birthday, setBirthday] = useState('')
  const [melicode, setMelicode] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [cityborn, setCityborn] = useState('')
  const [relation, setRelation] = useState('')
  const [instagramId, setInstagramId] = useState('')
  const [experience, setExperience] = useState('')
  const [part, setPart] = useState('')
  const [shift, setShift] = useState('')
  const [education, setEducation] = useState('')
  const [jobStatus, setJobStatus] = useState('')

  const token = localStorage.getItem('token')
  
  useEffect(() => {
    get(`/api/admin/im/jobs/${id}?token=${token}`)
      .then(response => {
        setName(response.data.data[0].name)
        setFather(response.data.data[0].fatherName)
        setBirthday(response.data.data[0].birthday)
        setMelicode(response.data.data[0].meliCode)
        setPhoneNumber(response.data.data[0].phoneNumber)
        setCityborn(response.data.data[0].cityBorn)
        setRelation(response.data.data[0].relation)
        setInstagramId(response.data.data[0].instagramId)
        setExperience(response.data.data[0].experienceHave)
        setPart(response.data.data[0].experiencePart)
        setShift(response.data.data[0].shift)
        setEducation(response.data.data[0].education)
        setJobStatus(response.data.data[0].status)
      }).catch(error => {
        console.log(error)
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [id, token])

  const statusHandler = () => {
    let data = { status: true }
    setJobStatus(!jobStatus)
    if (jobStatus) {
      data = { status: false }
    } else {
      data = { status: true }
    }
    put(`/api/admin/im/jobs/status/${id}?token=${token}`, data)
      .then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/im/jobs')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'job'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right' style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div className='text' >
                <div>
                </div>
                <Switch onChange={statusHandler} 
                  checked={jobStatus ? jobStatus : false} 
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={30}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                  className="react-switch"
                  id="material-switch"
                  />
              </div>
              <div>
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form'>
            <div className='title'>
              * با سوئیچ بالا میتوانید بررسی شدن یا نشدن آنرا مشخص کنید.
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات فرد
              <hr />
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>مشخصات :</label>
                <ul className='list'>
                  <li>نام و نام خانوادگی : {name ? name : ''}</li>
                  <li>نام پدر : {father ? father : ''}</li>
                  <li>شماره موبایل : {phoneNumber ? phoneNumber : ''}</li>
                  <li>کد ملی : {melicode ? melicode : ''}</li>
                  <li>تاریخ تولد : {birthday ? birthday : ''}</li>
                  <li>شهر محل سکونت : {cityborn ? cityborn : ''}</li>
                  <li>وضعیت تاهل : {relation ? relation : ''}</li>
                  <li>شناسه اینستاگرام : {instagramId ? instagramId : ''}</li>
                  <li>سابقه کاری مرتبط به کافه رستوران : {experience ? experience : ''}</li>
                  <li>بخش : {part ? part : ''}</li>
                  <li>شیفت : {shift ? shift : ''}</li>
                  <li>مدرک تحصیلی : {education ? education : ''}</li>
                </ul>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>وضعیت :</label>
                <ul className='list'>
                  <li style={jobStatus ? { color: '#198524' } : { color: '#fd3a50' }}>وضعیت : {jobStatus ? 'بررسی شده' : 'بررسی نشده'}</li>
                </ul>
              </div>
            </div>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
